import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import device from '../helpers/device'
import refs from '../helpers/refs'
import site from '../helpers/site'

gsap.registerPlugin(ScrollTrigger)

class CFeaturedProduct {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)
    this.site = site()
    this.bg = this.$refs.grillBackground

    if (this.site === 'chargriller') {
      this.initCG()
    } else {
      // MB using glide slider elements on home that resize images/videos
      // if GSAP triggers before the resizes are done the whole function fails
      // yes, this is a magic number
      setTimeout(() => {
        this.initGSAP()
      }, 500)
    }
  }

  initGSAP () {
    // [Left side] Desktop: Large images, Mobile: Background images
    const sceneImages = gsap.utils.toArray(
      '.c-featured-product__image-left .c-featured-product__listing'
    )
    // scene image panels are the images on the left
    sceneImages.forEach((panel, i) => {
      const productTimeline = gsap.timeline({
      // gsap.timeline({
        scrollTrigger: {
          // use markers: true to visually seee where the lines are
          // markers: true,
          // start and end values are: trigger element position, scroll/viewport position
          // top, bottom, center, pixels, percentages relative to top, query function
          // start when element position reaches scroll position
          start: 'top top',
          // start: i === sceneImages.length - 1 ? 'top+=50% bottom' : 'top top',
          // end: '100%',
          // end: i === sceneImages.length - 1 ? 'bottom bottom' : 'bottom+=100% 100%',
          end:
            i === sceneImages.length - 1
              // ? 'bottom bottom+=160px'
              ? 'bottom+=50% 150%'
              : 'bottom+=100% 100%',
          trigger: panel,
          pin: `.c-featured-product__image-left .c-featured-product__listing--${i} > .c-featured-product__listing-content`,
          // pin: true,
          pinSpacing: false,
          // scrub must be true for first image to disappear
          scrub: true
        }
      })

      const transitionDuration = device.isDesktop() ? 0.2 : 0.1
      switch (i) {
        case 0:
          productTimeline.to(
            panel,
            { opacity: 0, duration: transitionDuration },
            0.9
          ) // Fade out
          break
        case sceneImages.length - 1:
          productTimeline.to(panel, {
            opacity: 1,
            duration: transitionDuration
          }) // Fade in
          break
        default:
          productTimeline
            .to(panel, { opacity: 1, duration: transitionDuration }) // Fade in
            .to(panel, { opacity: 0, duration: transitionDuration }, 0.9) // Fade out
      }
    })

    // [Right side] List of grills (copy+image)
    if (device.isMobile()) {
      const contentBlocks = gsap.utils.toArray(
        '.c-featured-product__image-right .c-featured-product__listing'
      )
      contentBlocks.forEach((panel, i) => {
        const productTimeline = gsap.timeline({
          scrollTrigger: {
            start: device.isDesktop() ? 'top 170px' : 'top 60px',
            end:
              i === contentBlocks.length - 1
                // ? 'bottom bottom+=200px'
                ? 'bottom+=50% 150%'
                : 'bottom+=30% 50%',
            trigger: panel,
            pin: `.c-featured-product__image-right .c-featured-product__listing--${i} > .c-featured-product__listing-content`,
            pinSpacing: false,
            scrub: true
          }
        })

        const transitionDuration = device.isDesktop() ? 0.3 : 0.5
        switch (i) {
          case 0:
            productTimeline.to(
              panel,
              { opacity: 0, duration: transitionDuration },
              0.9
            ) // Fade out
            break
          case contentBlocks.length - 1:
            productTimeline.to(panel, {
              opacity: 1,
              duration: transitionDuration
            }) // Fade in
            break
          default:
            productTimeline
              .to(panel, { opacity: 1, duration: transitionDuration }) // Fade in
              .to(panel, { opacity: 0, duration: transitionDuration }, 0.9) // Fade out
        }
      })
    }
  }

  initCG () {
    const contentBlocks = gsap.utils.toArray('.c-featured-product__image-right .c-featured-product__listing')
    const productDescriptions = gsap.utils.toArray('.c-featured-product__image-right .c-featured-product__text-container')
    const sceneImages = gsap.utils.toArray('.c-featured-product__image-left .c-featured-product__listing')
    const leftPanel = this.component.querySelector('.c-featured-product__image-left')
    let leftPanelParent = leftPanel.parentElement

    // Safely replace overflow: hidden with overflow: clip to allow for sticky positioning (used in css)
    while (leftPanelParent) {
      if (getComputedStyle(leftPanelParent).getPropertyValue('overflow') === 'hidden') {
        leftPanelParent.style.overflow = 'clip'
      }
      leftPanelParent = leftPanelParent.parentElement
    }

    productDescriptions.forEach((el, i) => {
      const observer = new IntersectionObserver((entries) => {
        const [{ isIntersecting }] = entries
        if (!isIntersecting) { return }
        gsap.to(sceneImages[i], { opacity: 1, duration: 0.2 })
        gsap.to(sceneImages.filter((_, j) => j !== i), { opacity: 0, duration: 0.2 })
      })
      observer.observe(el)
    })

    if (device.isMobile()) {
      const rightPanel = this.component.querySelector('.c-featured-product__image-right')
      rightPanel.style.height = `${contentBlocks.length}00vh`

      gsap.timeline({
        scrollTrigger: {
          trigger: rightPanel,
          start: 'top top',
          end: 'bottom bottom',
          onUpdate: ({ progress }) => {
            const activeItem = Math.floor(progress * (contentBlocks.length - 1))
            gsap.to(contentBlocks[activeItem], { opacity: 1, duration: 0.2 })
            gsap.to(contentBlocks.filter((_, j) => j !== activeItem), { opacity: 0, duration: 0.2 })
          }
        }
      })
    }
  }
}

// GSAP components bug out if loaded too early, including before glide-slide is done loading
window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-c-featured-product]')
    .forEach(el => new CFeaturedProduct(el))
})
